import {gsap} from "gsap";
import {ReelView} from "../../../core/reel/simplereel/SimpleReelModel";
import {NineToFiveStatics} from "../../config/NineToFiveStatics";
import {NineToFiveGameAssets} from "../../NineToFiveGameAssets";
import {NineToFiveSymbol, SymbolArgs} from "./NineToFiveSymbol";
import {NineToFive} from "../../NineToFive";
import {SpineGSAPWrapper} from "../../animation/SpineGSAPWrapper";

export class NineToFiveXNudgeSymbol extends NineToFiveSymbol {
    public nudgeUp:boolean;
    public maxMultiplier:number;
    private currentMultiplier:number;
    private multiplierText:PIXI.BitmapText;
    private mainSprites:PIXI.Container;
    private mainSpritesContainer:PIXI.Container;
    public isActualSymbol:boolean;

    // The offset that the multiplier text gets during win animation.
    private multiplierWinPositionOffset:PIXI.Point = new PIXI.Point(20, -120);

    private multiplierStartScale:number = 0.65;

    private getMultiplierScale(multiplierValue:number):PIXI.Point {
        const multiplierMaxScale = 1;
        const multiplierScaleStep = 0.15;
        const additionalScale = Math.floor((multiplierValue / 3)) * multiplierScaleStep;
        return new PIXI.Point(
            Math.min(this.multiplierStartScale + additionalScale, multiplierMaxScale),
            Math.min(this.multiplierStartScale + additionalScale, multiplierMaxScale)
        );
    }

    // lord have mercy on our souls this ended up a mess
    constructor(args:SymbolArgs) {
        super(args);
        this.nudgeUp = args.bigSymbolData.topToBottom;
        if(args.isSpinning || args.reelPosition == -2) {
            this.isActualSymbol = true;
            const adjustedPosition = -NineToFiveStatics.SYMBOL_HEIGHT * 1.5;
            this.spinSprite.position.set(0, adjustedPosition);
            this.mainSprite.position.set(0, adjustedPosition);
            this.moveToNormalOverLayer();
        }else if ((args.reelPosition + 1) != args.bigSymbolData.actualSymbolIndex) {
            this.view.removeChild(this.mainSprite);
            this.view.removeChild(this.spinSprite);
            const adjustedPosition = -NineToFiveStatics.SYMBOL_HEIGHT * 1.5;
            this.spinSprite.position.set(0, adjustedPosition);
            this.mainSprite.position.set(0, adjustedPosition);
            this.isActualSymbol = false;
        } else {
            this.isActualSymbol = true;

            //this.mainSprite.position.set(0, adjustedPosition);
            const adjustedPosition = args.bigSymbolData.topToBottom
                ? NineToFiveStatics.SYMBOL_HEIGHT * 1.5
                : -NineToFiveStatics.SYMBOL_HEIGHT * 1.5

            this.mainSpritesContainer = new PIXI.Container();
            this.mainSpritesContainer.position.set(0, adjustedPosition);
            this.view.removeChild(this.mainSprite);
            this.spinSprite.position.set(0, args.bigSymbolData.topToBottom ? adjustedPosition : -adjustedPosition);

            this.mainSprites = new PIXI.Container();
            for (let i = 0; i < 4; i++) {
                const xNudgeSymbol = new PIXI.Sprite(NineToFive.assetLoader.getTextures(NineToFiveGameAssets.getSymbolStateTexturePath(this.symbolName))[0]);
                xNudgeSymbol.anchor.set(0.5, 0.5);
                xNudgeSymbol.position.set(0, i * (args.bigSymbolData.topToBottom ? 1 : -1) * NineToFiveStatics.SYMBOL_HEIGHT  * 4);
                this.mainSprites.addChild(xNudgeSymbol);
            }
            //this.mainSprites.position.set(0, adjustedPosition);
            this.mainSpritesContainer.addChild(this.mainSprites);

            //this.mainSpritesContainer.position.set(0, adjustedPosition);
            const symbolMask = new PIXI.Graphics();
            symbolMask.beginFill();
            symbolMask.drawRect(-NineToFiveStatics.SYMBOL_WIDTH / 2,
                                -NineToFiveStatics.SYMBOL_HEIGHT * 2,
                                NineToFiveStatics.SYMBOL_WIDTH,
                                NineToFiveStatics.SYMBOL_HEIGHT * 4);
            this.mainSpritesContainer.addChild(symbolMask);
            this.mainSpritesContainer.mask = symbolMask;

            this.view.removeChild(this.overlay);
            this.overlay.height = this.mainSpritesContainer.height;
            this.overlay.width = this.mainSpritesContainer.width;
            this.overlay.position.copyFrom(this.mainSpritesContainer.position);
            this.overlay.anchor.set(0.5,0.5);

            this.moveToNormalOverLayer()

            this.currentMultiplier = 1;
            this.maxMultiplier = args.xNudgeSize;
            this.multiplierText = new PIXI.BitmapText(`x${this.currentMultiplier}`, {
                fontName : NineToFiveGameAssets.BITMAP_FONT_FS_MULTI,
                fontSize : 60,
            });

            this.multiplierText.scale.set(this.multiplierStartScale, this.multiplierStartScale);
            this.multiplierText.position.set(0, adjustedPosition);
            (<PIXI.Point>this.multiplierText.anchor).set(0.5,0.5);

            this.view.removeChild(this.winAnimation);
            this.winAnimation = new PIXI.spine.Spine(NineToFive.assetLoader.getSpineAsset(NineToFiveGameAssets.X_NUDGE));
            this.winAnimation.position.set(0, adjustedPosition);

            this.view.removeChild(this.winBlink);
            this.winBlink.scale.y *= 4;
            this.winBlink.scale.y += 1.5 * NineToFiveStatics.SYMBOL_HEIGHT * (this.nudgeUp ? -1 : 1);
            if (this.nudgeUp) {
                this.winBlink.position.y -= NineToFiveStatics.SYMBOL_HEIGHT * 1.5;
            } else {
                this.winBlink.position.y += NineToFiveStatics.SYMBOL_HEIGHT * 1.5;
            }

            this.view.addChild(this.mainSpritesContainer);
            this.view.addChild(this.winAnimation);
            this.view.addChild(this.multiplierText);
            this.view.addChild(this.winBlink)
            this.view.addChild(this.overlay);
        }
    }

    public tickUpMultiplier():gsap.core.Timeline {
        // state :sob:
        const targetMultiplier = ++this.currentMultiplier;
        return gsap.timeline()
            .add(() => {
                this.multiplierText.text =  `x${targetMultiplier}`;
                this.multiplierText.scale.copyFrom(this.getMultiplierScale(targetMultiplier))
            })
    }


    public nudge(nudgeIndex:number, down:boolean = true):gsap.core.Timeline {
        return gsap.timeline()
            .add(this.tickUpMultiplier())
            .add(gsap.to(this.mainSprites.position, {
                y: this.mainSprites.position.y + nudgeIndex * (down
                   ? NineToFiveStatics.SYMBOL_HEIGHT
                   : -NineToFiveStatics.SYMBOL_HEIGHT),
                duration: 0.04,
                ease: "none"
            }), '<');
    }

    public getWinBlink():gsap.core.Timeline {
        return this.isActualSymbol
            ? gsap.timeline()
                .add(() => {this.winBlink.alpha = 1})
                .add(gsap.to(this.winBlink, {alpha: 0, duration: 0.08}), '>0.08')
            : gsap.timeline();
    }

    public getWinAnimationBased():gsap.core.Timeline {
        return this.maxMultiplier > 0
            ? gsap.timeline()
                .add(() => {
                    this.multiplierText.position.x += this.multiplierWinPositionOffset.x;
                    this.multiplierText.position.y += this.multiplierWinPositionOffset.y;
                })
                .add(super.getWinAnimationBased(), "<")
                .add(() => {
                    this.multiplierText.position.x = this.mainSpritesContainer.position.x;
                    this.multiplierText.position.y = this.mainSpritesContainer.position.y;
                })
            : gsap.timeline();
    }

    public showMultiplier():gsap.core.Timeline {
        return this.maxMultiplier != undefined
               ? gsap.timeline().add(gsap.to(this.multiplierText, {alpha: 1, duration: 0.1}))
               : gsap.timeline();
    }

    public resetState(): gsap.core.Timeline {
        // Reset multiplier text to the middle of the xNudge symbol
        return gsap.timeline()
            .add(() => {
                if (this.isActualSymbol && !this.nudgeUp) {
                    this.reelPosition -= 3;
                    this.position.y -= 3 * NineToFiveStatics.SYMBOL_HEIGHT;
                    this.mainSpritesContainer.position.y += 3 * NineToFiveStatics.SYMBOL_HEIGHT;
                }
                if(this.multiplierText) {
                    this.multiplierText.position.copyFrom(this.mainSpritesContainer.position);
                }
            })
            .add(super.resetState());
    }

    public restore(nudgeCount:number):void {
        this.currentMultiplier = this.maxMultiplier;
        this.multiplierText.text =  `x${this.currentMultiplier}`;
        this.mainSprites.position.y = this.mainSprites.position.y + nudgeCount * (!this.nudgeUp
                                                                                  ? NineToFiveStatics.SYMBOL_HEIGHT
                                                                                  : -NineToFiveStatics.SYMBOL_HEIGHT);
    }

    public moveToSpinLayer():void {
        this.reelsView.layers.xNudgeSpinContainer.addChild(this);
    }

    public moveCenterPointToTop():void {
        if (this.mainSprite != undefined && this.spinSprite != undefined) {
            const adjustedPosition = NineToFiveStatics.SYMBOL_HEIGHT * 1.5;
            this.spinSprite.position.set(0, adjustedPosition);
            this.mainSprite.position.set(0, adjustedPosition);
        }
    }
}

